/** design.md §4.2 — Moves 信号卡 14 种 event_type */
const MOVES_VIZ_EVENT_TYPES = [
  "price_52w_extreme",
  "volume_surge",
  "volume_anomaly",
  "volume_shrink",
  "ta_rsi_extreme",
  "ta_kdj_extreme",
  "ta_macd_cross",
  "ta_ema_cross",
  "ta_outlook_bullish",
  "ta_outlook_bearish",
  "sector_rotation",
  "earnings_flash",
  "earnings_call_ready",
  "ai_pick_published",
] as const;

export type MovesVizEventType = (typeof MOVES_VIZ_EVENT_TYPES)[number];

export const MOVES_VIZ_EVENT_TYPE_SET = new Set<string>(MOVES_VIZ_EVENT_TYPES);

export const MOVES_SIGNAL_CARD_ELEMENT_TYPES = new Set([
  "AssetVolumeComparisonCard",
  "AssetPriceSparklineCard",
  "AssetRsiGaugeCard",
  "AssetKdjGaugeCard",
  "AssetMacdMiniChartCard",
  "AssetEmaCandleChartCard",
  "AssetSentimentRatioCard",
  "AssetEarningsActualExpectedCard",
  "AssetInsightSummaryCard",
  "AssetTradePotentialCard",
  "AssetSectorShiftCard",
]);

export const MOVES_SIGNAL_VIZ_ELEMENT_ID = "signal-viz";
